import { Box, Paper, Stack, Typography } from '@mui/material';
import { currencyFormatter } from 'components/helpers/currency-formatter';
import { IContract } from '../types';
import { SectionSubtitle } from 'components/ui/typography';

interface ContractInsightsProps {
  contract: IContract;
  isVisible: boolean;
}

function ContractInsights({ contract, isVisible = true }: ContractInsightsProps) {
  if (!isVisible) return null;
  return (
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} paddingBottom={3}>
      {/* Card Annuale */}
      <Paper variant="outlined" sx={{ p: 2, flex: 1, bgcolor: 'background.paper' }}>
        <SectionSubtitle text="Valore Annuale Contratto" />
        <Box
          sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', mt: 1 }}>
          <Typography variant="body1" fontWeight="bold">
            {currencyFormatter(contract.annual_value, { significantDigits: 3 })}
          </Typography>
          <Typography
            variant="caption"
            sx={{
              bgcolor: 'action.hover',
              px: 1,
              py: 0.5,
              borderRadius: 1,
              color: 'success.main',
              fontWeight: 'bold'
            }}>
            Reale Valore:
            {currencyFormatter(contract.real_annual_value, { significantDigits: 3 })}
          </Typography>
        </Box>
      </Paper>

      {/* Card Totale */}
      <Paper variant="outlined" sx={{ p: 2, flex: 1, bgcolor: 'background.paper' }}>
        <SectionSubtitle text="Valore Contratto" />
        <Box
          sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', mt: 1 }}>
          <Typography variant="body1" fontWeight="bold">
            {currencyFormatter(contract.total_value, { significantDigits: 3 })}
          </Typography>
          <Typography
            variant="caption"
            sx={{
              bgcolor: 'action.hover',
              px: 1,
              py: 0.5,
              borderRadius: 1,
              color: 'info.main',
              fontWeight: 'bold'
            }}>
            Reale Valore:
            {currencyFormatter(contract.real_total_value, { significantDigits: 3 })}
          </Typography>
        </Box>
      </Paper>
    </Stack>

    // <div>
    //   <p className="mx-2 py-0 my-0">
    //     Valore Annuale Contratto:
    //     <b>{currencyFormatter(contract.annual_value, { significantDigits: 3 })}</b> - Reale Valore
    //     Annuale Contratto:
    //     <b>{currencyFormatter(contract.real_annual_value, { significantDigits: 3 })}</b>
    //   </p>
    //   <p className="mx-2 py-0 my-0">
    //     Valore Contratto: <b>{currencyFormatter(contract.total_value, { significantDigits: 3 })}</b>
    //     - Reale Valore Contratto:
    //     <b>{currencyFormatter(contract.real_total_value, { significantDigits: 3 })}</b>
    //   </p>
    // </div>
  );
}

export default ContractInsights;
